import { get, post } from '@/http/axios';

/**
 * 获取机械备案列表
 * @param {*} params
 * @returns
 */
export function getMachineRecordList(params) {
  return get({
    url: '/transfer/nonRoadMachineryRecord/page',
    params,
    hasLoading: true
  });
}

/**
 * 获取机械备案列表-导出
 * @param {*} params
 * @returns
 */
export function getMachineRecordExport(params) {
  return get({
    url: '/transfer/nonRoadMachineryRecord/out',
    params,
    hasLoading: true
  });
}

/**
 * 获取搜索栏上方的机械备案数据
 */
export function getRecordData(params = {}) {
  return get({
    url: '/transfer/nonRoadMachineryRecord/count',
    params
  });
}

/**
 * 机械备案
 */
export function submitRecord(vehicleFrameNo) {
  console.log('打印机械备案传参vehicleFrameNo---' + vehicleFrameNo);
  return post({
    url: '/transfer/nonRoadMachineryRecord/recordToPlatform',
    data: {
      vehicleFrameNo
    }
  });
}
/**
 * 删除机械备案信息
 */
export function deleteMachineRecord(data){
  return post({
    url: '/transfer/nonRoadMachineryRecord/remove',
    data
  });
}

